import { EChartsOption } from 'echarts';

export const savingsGraphAxisLine = {
	show: true,
	lineStyle: {
		color: '#c3c1c1',
		width: 1,
	},
};
export const savingsGraphAxisLabel = {
	color: '#949494',
};

export const savingsGraphConfig: EChartsOption = {
	grid: {
		show: false,
		containLabel: true,
		top: 100,
		left: 5,
		right: 5,
		bottom: 5,
		borderWidth: 0,
	},
	color: ['#8EB6FF', '#00007C', '#00CE46', '#FF0909'],
	legend: {
		itemGap: 25,
		show: true,
		top: 0,
		left: 0,
		icon: 'circle',
	},
	tooltip: {
		borderWidth: 0,
		backgroundColor: 'rgba(64, 64, 64, 0.8)',
		textStyle: {
			color: '#fff',
		},
		trigger: 'axis',
		axisPointer: {
			type: 'cross',
		},
		// Add $ prefix
		valueFormatter: (value) => '$' + +(value as any)?.toFixed(2),
	},
	xAxis: {
		show: true,
		type: 'category',
		data: [],
		boundaryGap: true,
		axisLine: savingsGraphAxisLine,
		axisLabel: savingsGraphAxisLabel,
		axisTick: {
			alignWithLabel: true,
		},
		axisPointer: {
			type: 'shadow',
		},
	},
	yAxis: [
		{
			show: true,
			type: 'value',
			min: '0',
			scale: false,
			axisTick: {
				show: true,
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: '#c3c1c1',
					type: 'solid',
					width: 1,
				},
			},
			axisLabel: {
				...savingsGraphAxisLabel,
				formatter: '${value}',
			},
			axisLine: savingsGraphAxisLine,
			axisPointer: {
				show: false,
			},
		},
		{
			show: true,
			type: 'value',
			min: '0',
			scale: false,
			axisTick: {
				show: true,
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: '#c3c1c1',
					type: 'solid',
					width: 1,
				},
			},
			axisLabel: {
				...savingsGraphAxisLabel,
				formatter: '{value}%',
			},
			axisLine: savingsGraphAxisLine,
			axisPointer: {
				show: false,
			},
		},
	],
	series: [
		{
			name: 'Zesty',
			type: 'bar',
			data: [],
			animationDelay: (idx) => idx * 10,
		},
		{
			name: 'Saving Plans',
			type: 'bar',
			data: [],
			animationDelay: (idx) => idx * 10 + 100,
		},
		{
			name: 'Zesty tolerance',
			type: 'line',
			yAxisIndex: 1,
			data: [],
			animationDelay: (idx) => idx * 10 + 200,
		},
		{
			name: 'Saving Plans tolerance',
			type: 'line',
			yAxisIndex: 1,
			data: [],
			animationDelay: (idx) => idx * 10 + 300,
		},
	],
	animationEasing: 'elasticOut',
	animationDelayUpdate: (idx) => idx * 5,
};
